import React from 'react'
import { withRouter } from 'react-router-dom'

const ScrollToTop = props => {
  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [props.location])

  return props.children
}

export default withRouter(ScrollToTop)
